<template>
  <div class="row">
    <div class="col-md-6">
      <v-text-input
        id="item-config-stars-min"
        label="phrase.min_value_label"
        placeholder="phrase.min_value_label"
        v-model="formData.config.min_text"
      />
    </div>
    <div class="col-md-6">
      <v-text-input
        id="item-config-stars-max"
        label="phrase.max_value_label"
        placeholder="phrase.max_value_label"
        v-model="formData.config.max_text"
      />
    </div>
  </div>
</template>

<script>
import TextInput from '@/common/components/inputs/TextInput.vue';

export default {
  name: 'ItemConfigStars',
  components: {
    'v-text-input': TextInput,
  },
  props: {
    formData: {
      type: Object,
      required: true,
    },
  },
};
</script>
